export default "__VITE_ASSET__470c9570__"